import { CancelTokenSource } from 'axios';
import { ArticleGroupDto, ArticleGroupSearchDto, UpsertArticleGroupDto } from 'ts-types/api.types';
import axios from 'services/http';

const { REACT_APP_API_BASE_URL: baseUrl } = process.env;
const apiUri = `${baseUrl}/api/article-groups`;

export const getAllArticleGroups = (
    source: CancelTokenSource): Promise<Array<ArticleGroupDto>> => {

  return axios
      .get(apiUri, { cancelToken: source.token })
      .then(response => response.data);
};

export const searchArticleGroups = (articleGroupsSearchRequest: Partial<ArticleGroupSearchDto>,
                                    source: CancelTokenSource): Promise<Array<ArticleGroupDto>> => {
  return axios
      .post(`${apiUri}/search`,articleGroupsSearchRequest, {cancelToken: source.token})
      .then(response => response.data)
};

export const findArticleGroupById = (
    id: number, source: CancelTokenSource): Promise<UpsertArticleGroupDto> => {

  return axios
      .get(`${apiUri}/${id}`, { cancelToken: source.token })
      .then(response => response.data);
};

export const addArticleGroup = (
    upsertArticleGroupDto: Partial<UpsertArticleGroupDto>,
    source: CancelTokenSource)
    : Promise<ArticleGroupDto> => {

  return axios
      .post(apiUri, upsertArticleGroupDto, {cancelToken: source.token})
      .then(response => response.data);
};

export const editArticleGroup = (
    id: number,
    upsertArticleGroupDto: Partial<UpsertArticleGroupDto>,
    source: CancelTokenSource)
    : Promise<ArticleGroupDto> => {

  return axios
      .put(`${apiUri}/${id}`,upsertArticleGroupDto, {cancelToken: source.token})
      .then(response => response.data);
};

export const deleteArticleGroup = (
    id: number, source: CancelTokenSource)
    : Promise<number> => {

  return axios
      .delete(`${apiUri}/${id}`, {cancelToken: source.token})
      .then(response => response.data)
};
